import { interceptor } from '@/common/utils/interceptor';
import * as Constants from '@/common/utils/constants';

export default [
  {
    path: '/mta/homepage',
    component: () => import('@/pages/mta/homepage'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    },
    children: [
      {
        path: 'ap',
        component: () => import('@/pages/mta/ap'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      },
      {
        path: 'record',
        component: () => import('@/pages/mta/record'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      }
    ]
  }
];
